import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@material-ui/core";
import React from "react";
import { IOption } from "../../models/IOption";

interface IRadioOptionsProps {
  label: string;
  options: IOption[];
  onChange: (options: IOption[]) => void;
  error?: () => boolean;
}

const RadioOptions = (props: IRadioOptionsProps) => {
  const { label, options, onChange } = props;

  const handleChange = (option: IOption) => {
    const newOpts = [];
    for (let i = 0; i < options.length; i++) {
      let opt = options[i];
      if (opt.Key === option.Key) {
        opt.Selected = true;
      } else {
        opt.Selected = false;
      }
      newOpts.push(opt);
    }
    onChange(newOpts);
  };

  const getLabel = (opt: IOption) => {
    return opt.Price ? `${opt.Description} ($${opt.Price})` : opt.Description;
  };

  return (
    <FormControl
      component="fieldset"
      style={{
        display: "block",
        marginTop: "10px",
        marginBottom: "20px",
      }}
    >
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup>
        {options.map(opt => {
          return (
            <FormControlLabel
              key={opt.Key}
              control={<Radio key={opt.Key} checked={opt.Selected} onClick={e => handleChange(opt)} value={opt.Key} />}
              label={getLabel(opt)}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioOptions;
